import apiWorker from '../apiWorker'

const analytics = {
    createSession : (data) =>  apiWorker('post', `/v1/analytics/portal_sessions`, data, true),
    pollComponent : (data) =>  apiWorker('post', `/v1/analytics/portal_sessions/poll`, data, true),
    increment     : (data) =>  apiWorker('post', `/v1/analytics/portal_sessions/increment`, data, true),
}

export default analytics;